import { LogsIcon } from "@minket/brand/icons/logs";
import { createFileRoute } from "@tanstack/react-router";
import { GhostTable } from "@/components/page/ghost";
import { Page } from "@/components/page/page";
import { ProjectScope } from "@/components/page/scope";
import { LogLedger, logColumns, retentionDays } from "@/components/sending/logs";

export const Route = createFileRoute("/logs")({
  component: Logs,
});

function Logs() {
  return (
    <Page title="Logs" description={`Kept ${retentionDays} days.`}>
      <ProjectScope
        will={`Each request made with this project's keys will be listed here, newest first, and kept for ${retentionDays} days.`}
        icon={<LogsIcon size={20} />}
        preview={(busy) => <GhostTable columns={logColumns} label="request logs" busy={busy} />}
      >
        {(project) => <LogLedger projectId={project.id} />}
      </ProjectScope>
    </Page>
  );
}
